import { useSyncExternalStore } from "react"

export const PHONE_QUERY = "(max-width: 639px)"

const phoneQuery =
	typeof window !== "undefined" ? window.matchMedia(PHONE_QUERY) : null

const subscribe = (callback: () => void) => {
	phoneQuery?.addEventListener("change", callback)
	return () => phoneQuery?.removeEventListener("change", callback)
}

/**
 * Read synchronously: useBreakpoints resolves in an effect, so its first render
 * reports desktop on a phone and anything gated on it paints the wrong layout once.
 */
export function useIsPhone(): boolean {
	return useSyncExternalStore(
		subscribe,
		() => phoneQuery?.matches ?? false,
		() => false,
	)
}
